import axios from 'axios';
import { removeToken } from 'helpers'
const handler = () => {
    axios.interceptors.response.use(undefined, function (error) {
        const statusCode = error.response ? error.response.status : null;

        if (statusCode === 404) {
            console.error('The requested resource does not exist or has been deleted');
            window.location.href = `//${window.location.host}${process.env.PUBLIC_URL}/login`;
        }

        if (statusCode === 401) {
            console.error('Please login to access this resource');
            window.location.href = `//${window.location.host}${process.env.PUBLIC_URL}/login`;
        }

        if (statusCode === 403) {
            console.error('Forbidden, redirect');
            window.location.href = `//${window.location.host}${process.env.PUBLIC_URL}/login`;
            removeToken();
        }

        if (statusCode === 400) {
            console.error('error 400');
        }

        if (!statusCode) {
            console.error('network error');
        }

        return Promise.reject(error);
    });
};

export default handler;
